import { Injectable } from '@angular/core';
import { PaymentIntentCreateRequest } from '../models/payment';

@Injectable({
  providedIn: 'root'
})

export class PaymentStripeService {

  /*
   * Afficher Stripe
   */
  public showStripe: boolean = false;

  /*
   * Choix du mode
   */
  public mode: string;

  /*
   * Id et quantité pour calculer le prix en back
   */
  public model: PaymentIntentCreateRequest = new PaymentIntentCreateRequest();

  /*
   * MontantPaiement
   */
  public paymentAmount: number;

  /*
   * Quand le processus est terminé, passe à true
   */
  public endProcess: boolean = false;

  /*
   * Valeur du wallet
   */
  public wallet: number = 0;


}
